import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule }         from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule }    from './app-routing.module';
import { HttpClientModule }    from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToolbarModule } from 'primeng/toolbar';
import { PanelModule } from 'primeng/panel';
import { ButtonModule } from 'primeng/components/button/button';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { MenuModule } from 'primeng/menu';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { BlockUIModule } from 'primeng/blockui';
import { TooltipModule } from 'primeng/tooltip';
import { DropdownModule } from 'primeng/dropdown';
import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { CalendarModule } from 'primeng/calendar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CaptchaModule } from 'primeng/captcha';
import { ToastModule } from 'primeng/toast';
import { CheckboxModule } from 'primeng/checkbox';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { InputMaskModule } from 'primeng/inputmask';
import { MenubarModule } from 'primeng/menubar';
import { MenuItem } from 'primeng/api';

import { AppComponent } from './app.component';
import { LoginComponent }   from './login/login.component';
import { SignupComponent }  from './signup/signup.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { HomeComponent } from './home/home.component';
import { NotFoundComponent } from './not-found/not-found.component'
import { ChooseAppComponent } from './choose-app/choose-app.component';
import { FacegateSubscriptionComponent } from './facegate-subscription/facegate-subscription.component'
import { FacegatePhotosComponent } from './facegate-photos/facegate-photos.component'

import { AuthService }          from './auth.service';
import { AuthGuard }            from './auth.guard';
import { SubscriptionService }  from './subscription.service';
import { LoadAppsSW2Service }   from './load-apps-sw2.service';
import { GestpayService }       from './gestpay.service'
import { CommunicationService } from './communication.service';
import { FacegateReportsComponent } from './facegate-reports/facegate-reports.component';
import { FacegatePaymentErrorComponent } from './facegate-payment-error/facegate-payment-error.component';
import { FacegatePaymentSuccessComponent } from './facegate-payment-success/facegate-payment-success.component';
import { FacegateReportConfigComponent } from './facegate-report-config/facegate-report-config.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ToolbarModule,
    PanelModule,
    ButtonModule,
    MessagesModule,
    MessageModule,
    MenuModule,
    DialogModule,
    TableModule,
    BlockUIModule,
    TooltipModule,
    DropdownModule,
    VirtualScrollerModule,
    CalendarModule,
    ProgressSpinnerModule,
    CaptchaModule,
    ToastModule,
    CheckboxModule,
    OverlayPanelModule,
    InputMaskModule,
    MenubarModule,
  ],
  declarations: [
    AppComponent,
    LoginComponent,
    SignupComponent,
    ConfirmComponent,
    HomeComponent,
    NotFoundComponent,
    ChooseAppComponent,
    FacegateSubscriptionComponent,
    FacegatePhotosComponent,
    FacegateReportsComponent,
    FacegatePaymentErrorComponent,
    FacegatePaymentSuccessComponent,
    FacegateReportConfigComponent,
    ChangePasswordComponent,
    ForgotPasswordComponent
  ],
  providers: [
    AuthService,
    AuthGuard,
    SubscriptionService,
    LoadAppsSW2Service,
    GestpayService,
    CommunicationService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
